var $f8363ab25362c4ab$exports = {};
$f8363ab25362c4ab$exports = {
    "loading": `Na\u{10D}\xedtava sa...`,
    "placeholder": `Vybra\u{165}\u{2026}`
};


export {$f8363ab25362c4ab$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
